import { Component } from "@angular/core";

@Component({
  selector: "app-brand-email-connected",
  templateUrl: "./brand-email-connected.component.html",
  styleUrl: "./brand-email-connected.component.scss",
})
export class BrandEmailConnectedComponent {}
